import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';
import {Router} from '@angular/router';

import {AuthenticationService} from '../services/authentication.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
    ) {
    }

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        let updatedRequest;
        if(this.authenticationService.isSSO && !request.url.includes(environment.ssoUrl)){
          updatedRequest = request.clone({
            setHeaders: {
              Authorization: `Bearer ${this.authenticationService.bearerToken}`,
            },
          });
        } else {
          updatedRequest = request.clone({
            setHeaders: {
              AuthorizationLDAP: `Bearer ${this.authenticationService.bearerToken}`,
            },
          });
        }

        return next.handle(updatedRequest).pipe(
            catchError((err: HttpErrorResponse) => {
                if (err.status === 403 || err.status === 401 && !err?.error?.includes('authentication failed')) {
                  this.router.navigate(['/login']);
                }
                return throwError(() => err);
            }),
            finalize(() => {
            })
        );
    }
}
